import PropTypes from 'prop-types';
import { IconChevronDown } from '@tabler/icons-react';
import classes from './memberCard.module.css';

const MemberCard = (props) => {
  const {
    id,
    img,
    name,
    position,
    description,
  } = props;

  const computedId = `member${id}`;

  return (
    <div className={classes.card}>
      <input type="checkbox" id={computedId} name="member"></input>
      <img src={img} alt={`${name}-img`} draggable="false" />
      <label htmlFor={computedId} className={classes.info}>
        <div className={classes.name}>{name}</div>
        <div className={classes.position}>{position}</div>
        <div className={classes.description}>{description}</div>
        <div className={classes.icon}><IconChevronDown /></div>
      </label>
    </div>
  );
};

export default MemberCard;

MemberCard.propTypes = {
  id: PropTypes.string,
  img: PropTypes.string,
  name: PropTypes.string,
  position: PropTypes.string,
  description: PropTypes.string,
};
